<template>
  <highcharts ref="chart" :options="options" />
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'GHGIsBar',
  props: {
    ghgis: {
      type: Array,
      default: null
    },
    modules: {
      type: Array,
      default: function () {
        return []
      }
    },
    colors: {
      type: Object
    },
    perCapita: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    series: function () {
      let series = []
      for (let module of this.modules) {
        series.push({
          name: this.$t(module),
          data: this.ghgis.map((ghgi) => {
            let divider = 1000
            if (this.perCapita) {
              divider *= ghgi.boundary.workforce
            }
            return ghgi.carbonSynthesis[module].intensity / divider
          }),
          color: this.colors[module]
        })
      }
      return series
    },
    categories: function () {
      return this.ghgis.map((ghgi) => ghgi.year)
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: this.series,
        tooltip: {
          valueSuffix: ' ' + this.$t('t.co2e'),
          valueDecimals: 2,
          shared: true
        },
        xAxis: {
          categories: this.categories,
          crosshair: true
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              formatter () {
                return `${this.y.toFixed(2)}`
              }
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('emissions.t.co2e')
          }
        }
      }
    }
  }
}
</script>
